import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { SimpleModal } from '@festina-life/ui/structure'
import type { HierarchyNode } from '@visx/hierarchy'
import { useState } from 'react'

import { useTemplateId } from '../../hooks/useTemplateId'
import { SubTemplateDiagram } from './SubTemplateDiagram'
import type { TreeNode } from './types'

type Props = {
  className?: string
  d3Hierarchies: HierarchyNode<TreeNode>[]
}

export const SubTemplateDiagramActions = ({
  className,
  d3Hierarchies,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const translate = useTranslate()
  const templateId = useTemplateId()

  return (
    <div className={className}>
      <Button
        startIcon="ArrowTopRightOnSquare"
        onClick={() => setIsModalOpen(true)}
        className="flex items-center gap-x-2"
        variant="discreet"
      >
        {translate(
          'templateViewer.sidebar.subtemplateDiagram.modalButton.open',
        )}
      </Button>
      <SimpleModal
        isOpen={isModalOpen}
        title={translate(
          'templateViewer.sidebar.subtemplateDiagram.modal.title',
          { templateName: templateId },
        )}
        closeConfiguration={{
          onClose: () => setIsModalOpen(false),
          label: translate('close'),
        }}
      >
        <div className="flex">
          {d3Hierarchies.map((d3Hierarchy) => (
            <SubTemplateDiagram
              key={d3Hierarchy.data.id}
              d3Hierarchy={d3Hierarchy}
            />
          ))}
        </div>
      </SimpleModal>
    </div>
  )
}
